import { $, validate } from "../../../iawp/src/js/factory"
import IAScrollAnimation from "./IAScrollAnimation"

const answers = {}
function initProductFinderSubmissionForm() {
    let isProductFinderSubmitted = false

    document.querySelector('[href="#start-quizz"]').addEventListener('click', e => {
        e.preventDefault()
        e.stopImmediatePropagation()
        e.target.closest('.has-quizz').classList.add('is-visible')
    })
    document.querySelector('.quit-quizz').addEventListener('click', e => {
        e.preventDefault()
        e.stopImmediatePropagation()
        e.target.closest('.has-quizz').classList.remove('is-visible')
    })

    document.querySelectorAll('.ia-block-product-finder-submission').forEach(function(block, indexBCS) {
        block.parentElement.classList.add('has-quizz')
        let steps = block.querySelectorAll('.ia-block-submission-step')
        steps = [...steps].filter(b => {
            return !b.classList.contains('ia-block-submission-step--confirmation-step') && !b.classList.contains('ia-block-submission-step--error-step') && !b.classList.contains('ia-block-submission-step--fail-step')
        })
        block.querySelector('.total-steps').innerHTML = steps.length



        let form = block.querySelector('.ia-block-submission__inner-container') 

        
        steps.forEach((step, i) => {
            if (i > 0) {
                step.setAttribute('aria-expanded', 'false')
            }

            let nextStep = i + 1
            let currentStep = i
            let prevStep = i - 1

            step.querySelectorAll('.js-prev-question').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    goToStep(currentStep, prevStep, block)
                })
            })

            step.querySelectorAll('label').forEach(a => {
                a.addEventListener('click', (e) => {
                    let answer = e.target.previousElementSibling;
                    answers[answer.name] = answer.value
                    if(nextStep + 1 > steps.length) {
                        setTimeout(() => {
                            document.getElementById('form-product-finder').submit();
                        }, 10);
                        return
                    }

                    goToStep(currentStep, nextStep, block)
                    
                    let element = document.getElementById('ia-product-finder');
                    let headerHeight = document.querySelector('.section-header').offsetHeight + document.querySelector('.section-topbar').offsetHeight;
                    let elemScrollTo = window.pageYOffset + element.getBoundingClientRect().top;
                    window.scrollTo({
                        top: elemScrollTo - headerHeight - 40,
                        behavior: 'smooth'
                    });
                })
            })
        })

        // block.querySelector('.ia-block-submission-step--confirmation-step .js-reset-question').addEventListener('click', (e) => {
        //     let currentStep = e.currentTarget.closest('.ia-block-submission-step')
        //     goToStep(currentStep, steps[0], block)
        //     block.querySelector('.current-step').innerHTML = 1

        //     block.querySelectorAll('.fake-button input[type="radio"').forEach((input) => input.checked = null)
        // })
    })
}

function goToStep(currentStep, newStep, block) {
    let steps = block.querySelectorAll('.ia-block-submission-step')
    steps = [...steps].filter(b => {
        return !b.classList.contains('ia-block-submission-step--confirmation-step') && !b.classList.contains('ia-block-submission-step--error-step') && !b.classList.contains('ia-block-submission-step--fail-step')
    })

    //console.log({isNanCurrent: isNaN(currentStep), isNanNew: isNaN(newStep) })

    if (steps[currentStep]) {
        steps[currentStep].setAttribute('aria-expanded', 'false')
    } else if (!!currentStep) {
        currentStep.setAttribute('aria-expanded', 'false')
    }
    if (steps[newStep]) {
        steps[newStep].setAttribute('aria-expanded', 'true')
        block.querySelector('.current-step').innerHTML = newStep + 1
    } 
    // else if (!!newStep) {
    //     newStep.setAttribute('aria-expanded', 'true')
    // }

    document.querySelectorAll('.ia-block-submission-steps__step-bullet').forEach((step, index) => {
        step.classList.remove('active')
        if(index <= newStep) {
            step.classList.add('active')
        }
    })
}

function productQuiz() {
    // document.getElementById('searchProduct').addEventListener('click', function(e) {
    //     e.preventDefault();

       
    //     var price = document.querySelector('.question-answer[name="step_3"]:checked').value
        

    //     var xhr = new XMLHttpRequest();
    //     xhr.open('POST', ajaxurl, true);
    //     xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    //     xhr.onload = function() {
    //         if (xhr.status >= 200 && xhr.status < 400) {
    //             var response = JSON.parse(xhr.responseText);
    //             if (response.success) {
    //                 var products = response.data;
    //                 var output = '';

    //                 products.forEach(function(product) {
    //                     let item = `
    //                     <li class="product">
    //                         <div class="ia-block-wc-product">
    //                         <a href="${product.link}" class="woocommerce-LoopProduct-link woocommerce-loop-product__link">
    //                             <figure class="ia-block-wc-product__visual">
    //                                 <img width="300" height="300" src="${product.image}" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="${product.title}" decoding="async">
    //                             </figure>
    //                         </a>
    //                         <div class="ia-block-wc-product__contents">
    //                             <a href="${product.link}" class="woocommerce-LoopProduct-link woocommerce-loop-product__link">
    //                                 <h2 class="woocommerce-loop-product__title">${product.title}</h2>
    //                                 <span class="price">${product.price}</span>
    //                             </a>
    //                         </div>
    //                     </li>`
    //                     output += item;
    //                 });
    //                 if (products.length > 0) {
    //                     document.querySelector('.ia-block-submission-step--confirmation-step .step-header .total-results').innerHTML = products.length
    //                     document.querySelector('.ia-block-submission-step--confirmation-step .step-body').innerHTML = '<ul class="products columns-2">' + output + '</ul>'
    //                     document.querySelector('.ia-block-submission-step--confirmation-step').setAttribute('aria-expanded', true)
    //                 } else {
    //                     document.querySelector('.ia-block-submission-step--error-step').setAttribute('aria-expanded', true)
    //                 }
    //             } else {
    //                 document.querySelector('.ia-block-submission-step--fail-step').setAttribute('aria-expanded', true)
    //             }
    //         } else {
    //             console.log('AJAX Error: ' + xhr.status);
    //         }
    //     };

    //     xhr.onerror = function() {
    //         console.log('Request Error...');
    //     };

    //     var data = 'action=get_products_for_quiz' +
    //                 '&price' + encodeURIComponent(price) 
    //     xhr.send(data);
    // });


    
}

function addAnchor(payload) {
    const params = new URLSearchParams(payload).toString()
    window.location.hash = `params${params}`
}


function queryStringToObject(queryString) {
    if (!queryString) {
        return {};
    }

    const paramsObject = {};

    const params = queryString.split('&');

    params.forEach(function(param) {
        const parts = param.split('=');
        const key = decodeURIComponent(parts[0]);
        const value = decodeURIComponent(parts[1] || '');

        if (!paramsObject[key]) {
            paramsObject[key] = value;
        } else if (Array.isArray(paramsObject[key])) {
            paramsObject[key].push(value);
        } else {
            paramsObject[key] = [paramsObject[key], value];
        }
    });

    return paramsObject;
}

export { initProductFinderSubmissionForm}
